var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromociones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_92",
    "data-name": "Rect\\xE1ngulo 92",
    width: 22.565,
    height: 18.625,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Promociones"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Promociones",
    clipPath: "url(#clip-Promociones)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_239",
    "data-name": "Grupo 239",
    transform: "translate(3.718 5.688)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_127",
    "data-name": "Trazado 127",
    d: "M6.462,6.242v6.141a18.8,18.8,0,0,1,8.205,4V2.243a18.844,18.844,0,0,1-8.205,4M15.225,9.3q0,2.092,0,4.185c0,1.238-.006,2.476,0,3.715a1.428,1.428,0,0,0,1.8,1.38A1.445,1.445,0,0,0,18.089,17.1q0-7.787,0-15.575c0-.06,0-.119,0-.179a1.432,1.432,0,0,0-2.861.117q0,3.916,0,7.832M5.9,6.284H2.886v6.062H5.9Zm-3.59,6.089v-6.1c-.242,0-.479,0-.716,0a1.607,1.607,0,0,0-1.591,1.6q-.012,1.443,0,2.886a1.573,1.573,0,0,0,1.308,1.56,8.437,8.437,0,0,0,1,.055m.575.53a.416.416,0,0,0-.017.077c0,1.044,0,2.087,0,3.131a.527.527,0,0,0,.557.544c.365.006.73,0,1.1,0a.557.557,0,0,0,.632-.5q.246-.974.489-1.949c.108-.431.214-.861.325-1.306ZM21.5,4.652a.521.521,0,0,0-.737-.485c-.556.249-1.1.518-1.65.791a.518.518,0,0,0-.242.7.524.524,0,0,0,.7.257c.547-.251,1.089-.515,1.63-.78a.507.507,0,0,0,.3-.486m-2.1,8.011a.539.539,0,0,0-.561.419.523.523,0,0,0,.307.6c.52.256,1.041.51,1.568.749a.684.684,0,0,0,.386.045.477.477,0,0,0,.394-.43.5.5,0,0,0-.283-.556c-.539-.268-1.083-.525-1.627-.782a.815.815,0,0,0-.185-.049M21.128,9.85c.29,0,.581,0,.871,0a.537.537,0,1,0,0-1.071q-.86-.008-1.719,0a.538.538,0,1,0,0,1.072c.283,0,.566,0,.848,0",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_128",
    "data-name": "Trazado 128",
    d: "M108.062,41.514a18.843,18.843,0,0,0,8.205-4V51.654a18.8,18.8,0,0,0-8.205-4Z",
    transform: "translate(-101.6 -35.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_129",
    "data-name": "Trazado 129",
    d: "M254.579,9.3q0-3.916,0-7.832a1.432,1.432,0,0,1,2.861-.117c0,.06,0,.119,0,.179q0,7.787,0,15.575a1.445,1.445,0,0,1-1.065,1.474,1.428,1.428,0,0,1-1.8-1.38c-.009-1.238,0-2.476,0-3.715q0-2.092,0-4.185",
    transform: "translate(-239.354 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_91",
    "data-name": "Rect\\xE1ngulo 91",
    width: 3.017,
    height: 6.062,
    transform: "translate(2.886 6.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_130",
    "data-name": "Trazado 130",
    d: "M2.312,110.918a8.435,8.435,0,0,1-1-.055A1.573,1.573,0,0,1,.005,109.3q-.011-1.443,0-2.886a1.607,1.607,0,0,1,1.591-1.6c.237,0,.474,0,.716,0Z",
    transform: "translate(0 -98.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_131",
    "data-name": "Trazado 131",
    d: "M47.99,215.785h3.082c-.11.444-.217.875-.325,1.305q-.244.975-.489,1.949a.557.557,0,0,1-.632.5c-.365,0-.731,0-1.1,0a.527.527,0,0,1-.557-.544c-.006-1.044,0-2.087,0-3.131a.412.412,0,0,1,.017-.077",
    transform: "translate(-45.102 -202.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_132",
    "data-name": "Trazado 132",
    d: "M317.357,69.435a.508.508,0,0,1-.3.485c-.541.265-1.083.529-1.63.78a.524.524,0,0,1-.7-.256.518.518,0,0,1,.242-.7c.545-.273,1.093-.542,1.65-.791a.521.521,0,0,1,.737.485",
    transform: "translate(-295.858 -64.782)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_133",
    "data-name": "Trazado 133",
    d: "M315.368,211.785a.815.815,0,0,1,.185.049c.544.257,1.088.514,1.627.782a.5.5,0,0,1,.283.556.477.477,0,0,1-.394.43.684.684,0,0,1-.386-.045c-.528-.239-1.048-.493-1.568-.749a.523.523,0,0,1-.307-.6.539.539,0,0,1,.56-.419",
    transform: "translate(-295.97 -199.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_134",
    "data-name": "Trazado 134",
    d: "M330.93,147.808c-.283,0-.566,0-.848,0a.538.538,0,1,1,0-1.072q.86-.006,1.719,0a.537.537,0,1,1,0,1.071c-.29.005-.581,0-.871,0",
    transform: "translate(-309.803 -137.957)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromociones);
export default __webpack_public_path__ + "static/media/Promociones.d8d5f6f3dbad5e38098ba67824594b69.svg";
export { ForwardRef as ReactComponent };